module.exports = __webpack_public_path__ + "img/12-down-the-mtn_v8e_loading.9177da84.jpg";